<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/Itinerari-esperienze/01_Pollino//01_5__Santuari/04d_Santuario-Santa-Maria-Armi.jpg">
<div class="content">
    <h1>Pollino</h1>
    <h3>Cammini di spiritualità e natura</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a>Parchi e Riserve</a> > <a>Parco Nazionale del Pollino</a> > <a class="active">Cammini di spiritualità e natura</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div class="row schedaItinerario">
    <h2>Un viaggio spirituale tra Santuari e paesaggio nel Parco Nazionale del Pollino</h2>
</div>
<br>
<div class="row schedaItinerario">
    <div class="col-xl-6 col-12">
        <img class="itinerario-foto" src="../../../assets/images/Itinerari-esperienze/01_Pollino/01_5__Santuari/04d_Santuario-Santa-Maria-Armi.jpg">
    </div>
    <div class="col-xl-4 ml-4 col-12">
        <div id="map" class="mapInfo"></div>
    </div>
</div>
<br>
<div class="row schedaItinerario">
    <div class="col-xl-6 col-12">
        <p class="testoItinerario">
            Situato a cavallo tra Basilicata e Calabria, il Parco Nazionale del Pollino ha anche un ricco patrimonio architettonico-religioso: 
            chiese, santuari, monasteri, conventi. Questo itinerario, da percorrere in bici, 
            propone tre tappe alla scoperta di alcuni dei Santuari più significativi dell’area Parco. 
            L’itinerario parte dal Santuario della Madonna del Pollino, nel territorio di San Severino Lucano, 
            che si trova in posizione dominante alle pendici dell’omonimo monte a oltre 1550 m, da sempre meta di pellegrinaggio per tutti i fedeli lucani e calabri; 
            è qui che la prima domenica di luglio, per tre giorni prende vita una grande festa popolare che si svolge a ritmo di musiche e danze popolari fino alla domenica, 
            giorno in cui la statua viene riportata in paese accompagnata da una lunga processione.
            Ripartiti dal Pollino si procede in direzione sud lungo la SS92, 
            si supera il bivio per Cerchiara e si devia verso il magnifico Santuario di Santa Maria delle Armi (dal greco “ton armon”, “delle grotte”), 
            incastonato nella roccia e che ingloba al suo interno la grotta che custodisce in una teca d’argento la miracolosa immagine della Madonna.
            <br>
            <br>
            Rientrati a Cerchiara si fa sosta nel paese noto per la produzione del pane tanto da raccontarne la storia in un museo, 
            che offre un centro storico davvero interessante che risale all’epoca longobarda, 
            collocato sul versante est del monte Sellaro (1439 m s.l.m.) che guarda la Piana di Sibari.
            Il viaggio riparte in direzione in direzione sud-ovest verso Spezzano Albanese. Superata Roggiano Gravina, 
            si risale verso San Sosti e da qui si percorrono circa due Km in ripida salita per raggiungere il Santuario della Madonna del Pettoruto. 
            Incastonato nei declivi rocciosi dell’Orsomarso, da cui deriva il nome che trae origine da “petruto” che vuol dire “roccioso, irto di pietre”, 
            il Santuario Regionale Basilica Minore Maria SS.ma Incoronata del Pettoruto sin dalla metà del XV secolo è meta di pellegrinaggi da tutta la valle dell’Esaro
             e dall’intera Calabria.
        </p>
    </div>
    <div class="col-xl-4 ml-4 col-12">
        <div class="row">
            <div class="col">
                <h5>Percorso:</h5>
            </div>
            <div class="col right">
                <h5> in bici</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Difficoltà:</h5>
            </div>
            <div class="col right">
                <h5>elevata</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Lunghezza:</h5>
            </div>
            <div class="col right">
                <h5>110 Km</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Giorni:</h5>
            </div>
            <div class="col right">
                <h5>2</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Salita:</h5>
            </div>
            <div class="col right">
                <h5>1660 m</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Discesa:</h5>
            </div>
            <div class="col right">
                <h5>2630 m</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Luogo di Partenza:</h5>
            </div>
            <div class="col right">
                <h5>Santuario Madonna del Pollino (San Severino Lucano)</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Luogo di arrivo:</h5>
            </div>
            <div class="col right">
                <h5>Santuario Madonna del Pettoruto (San Sosti)</h5>
            </div>
        </div>
        <div class="divider"></div>
    </div>
</div>
<br>
<br>
<div class="divider2">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-7 col-xl-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco Nazionale del Pollino.</p>
    </div>
    <div class="col-1 col-xl-1">
        <img src="../../../assets/images/04_Pollino/logo-pollino.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-12 col-xl-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sui sentieri dei<br />"Patriarchi"</h1>
                        <a (click)="goToPatriarchi()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Lungo le strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goTo()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Alle origini<br />dell'avventura<br />umana</h1>
                        <a (click)="goToAvventuraUmana()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>
    <div class="row">
        <div class="col-12 col-xl-3 four" id="four">
            <div class="card four">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Viaggio nella<br />cultura<br />arberëshe</h1>
                        <a (click)="goToCulturaArbereshe()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 five" id="five">
            <div class="card five">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Cammini di<br />spiritualità e<br />natura</h1>
                        <a (click)="goToSpiritualitaENatura()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 six" id="six">
            <div class="card six">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Percorsi<br />di gusto</h1>
                        <a (click)="goToPercorsiDiGusto()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider2">
    
</div>
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>
